module.exports = __webpack_public_path__ + "img/logo.bded59b3.png";